<template>
    <b-card class="inner-page p-3 item-type-view">
        <div class="d-flex title-bar-block mb-4">
            <div class="icon-block me-4">
                <button id="close-label-btn" v-b-tooltip.hover :title="$backLabel()" @click="cancel()">
                    <i class="fa fa-chevron-left text-white" aria-hidden="true"></i>
                </button>
            </div>
            <div class="text">
                <span class="me-2">{{ title }}</span>
            </div>
        </div>


        <b-card-body>
            <b-overlay :show="loading" rounded="sm">
                <b-form class="form-sample p-0" @submit.stop.prevent="onSubmit">
                    <b-row>
                        <b-col cols="12" md="6">
                            <!-- <b-form-group id="name-group" label="Name*" label-for="input-name" label-cols="12"
                                label-cols-md="3"> -->
                            <label class="mb-3"><strong>{{ $translate('name') }} <span class="red">*</span></strong></label>
                            <b-form-input type="text" id="input-name" v-custom-validation="$textRequired()"
                                v-model="model.name" required :placeholder="$translate('enter_name')" trim></b-form-input>
                            <!-- </b-form-group> -->
                        </b-col>
                        <b-col cols="12" md="6" class="mt-3 mt-md-0">
                            <label class="mb-3"><strong>{{ $translate('description') }}</strong></label>
                            <b-form-input type="text" id="input-description" v-model="model.description"
                                :placeholder="$translate('enter_description')" trim></b-form-input>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col cols="12" md="6" class="mt-3">
                            <label for="input-tax_rate" class="mb-3"><strong>{{ $translate('tax_rate') }}</strong></label>
                            <b-form-input type="number" step="any" id="input-tax_rate" v-model="model.tax_rate"
                                :placeholder="$translate('enter_tax_rate')" trim></b-form-input>
                        </b-col>
                        <b-col cols="12" md="6" class="mt-3">
                            <label for="input-uom" class="mb-3"><strong>{{ $translate('uom') }}</strong></label>
                            <b-form-select class="form-control" id="input-uom" value-field="id" text-field="name"
                                v-model="model.uom" :options="unitMeasures">
                                <template #first>
                                    <b-form-select-option :value="null" disabled>{{ $translate('select_uom')
                                    }}</b-form-select-option>
                                </template>
                            </b-form-select>
                            <!-- <b-form-input type="text" id="input-uom" v-model="model.uom"
                                :placeholder="$translate('unit_of_measure')" trim></b-form-input> -->
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" md="6" class="mt-3">
                            <label for="input-size_uom" class="mb-3"><strong>{{ $translate('size_uom') }}</strong></label>
                            <b-form-input type="text" id="input-size_uom" v-model="model.size_uom"
                                :placeholder="$translate('size_unit_of_measure')" trim></b-form-input>
                        </b-col>
                        <b-col cols="12" md="6" class="mt-3 d-flex align-items-end">
                            <div class="d-flex flex-md-row flex-column gap-4 three-check">
                                <b-col cols="auto" class="d-flex">
                                    <div class="form-check">
                                        <label class="form-check-label lh-base">
                                            <input type="checkbox" class="form-check-input top-2" id="input-is_task"
                                                v-model="model.is_task" name="checkbox-expandedList" :value="true"
                                                :unchecked-value="false" />
                                            <i class="input-helper"></i>
                                        </label>
                                    </div>
                                    <label for="input-is_task" class="ms-3"><strong>{{ $translate('is_task') }}<span
                                                class="red">*</span></strong></label>
                                </b-col>

                                <b-col cols="auto" class="d-flex">
                                    <div class="form-check">
                                        <label class="form-check-label lh-base">
                                            <input type="checkbox" class="form-check-input top-2" id="input-is_order_task"
                                                v-model="model.is_order_item" name="checkbox-expandedList" :value="true"
                                                :unchecked-value="false" />
                                            <i class="input-helper"></i>
                                        </label>
                                    </div>
                                    <label for="input-is_order_task" class="ms-3"><strong>{{ $translate('is_order_item')
                                    }}<span class="red">*</span></strong></label>
                                </b-col>

                                <b-col cols="auto" class="d-flex">
                                    <div class="form-check">
                                        <label class="form-check-label lh-base ">
                                            <input type="checkbox" class="form-check-input top-2" id="input-is_discount"
                                                v-model="model.is_discount" name="checkbox-expandedList" :value="true"
                                                :unchecked-value="false" />
                                            <i class="input-helper"></i>
                                        </label>
                                    </div>
                                    <label for="input-is_discount" class="ms-3"><strong>{{ $translate('is_discount')
                                    }}</strong></label>
                                </b-col>
                               
                            </div>
                        </b-col>
                        <b-col cols="12" md="6" class="mt-3">
                            <label class="mb-3"><strong>{{ $translate('item_type_group') }}</strong></label>
                              <b-form-select
                                id="input-item_type_group"
                                v-model="model.item_type_group_id"
                                :options="itemTypeGroups"
                            
                              ></b-form-select> 
                            </b-col>
                    </b-row>
                    <b-col md="12" class=" mb-2 mt-4 text-center">
                        <b-button id="item-type-create-btn" class="btn btn-info btn-fw me-2" type="submit" v-if="hasPermissionCreate && !model.id"
                            variant="primary" :disabled="loading ? true : false">{{ createLabel }}</b-button>
                        <b-button id="item-type-update-btn" class="btn btn-info btn-fw me-2" type="submit" v-if="hasPermissionUpdate && model.id"
                            variant="primary" :disabled="loading ? true : false">{{ updateLabel }}</b-button>
                        <b-button id="item-type-delete-btn" v-if="this.model.id && hasPermissionDelete" @click="deleteItem()" class="me-2" size="fw"
                            variant="delete-button">
                            {{ $translate('delete_item') }}
                        </b-button>
                        <b-button id="item-type-cancel-btn" class="btn-fw" variant="info" :disabled="loading ? true : false" @click="cancel()">{{
                            $translate('cancel') }}</b-button>

                    </b-col>
                    <!-- <b-button-group size="sm"> -->
                    <!-- </b-button-group> -->
                </b-form>
            </b-overlay>
        </b-card-body>
    </b-card>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'

export default {
    name: 'ItemTypes-view',
    mixins: [popupMixins, permissionsMixins],
    data() {
        return {
            model: {
                id: 0,
                name: null,
                description: null,
                uom: null,
                size_uom: null,
                is_task: false,
                is_order_item: false,
                is_asset: false,
                is_discount: false,
            },
            loading: false,
            hasErrors: false,
        }
    },
    props: ['item'],
   
    computed: {
        title() {
            return this.model.id ? this.$translate('edit_item_type') : this.$translate('new_item_type')
        },
        unitMeasures() {
            return this.$store.state.masterItem.unit_of_measures && this.$store.state.masterItem.unit_of_measures.map(x => ({ id: x.name, ...x }))
        },
        itemTypeGroups(){
            return this.$store.state.item_type_group.items_not_paginated.map(x => ({
                value: x.id,
                text: x.name,
            }));
        },

        createLabel() {
            if (this.loading) {
                return this.$translate('creating')
            } else {
                return this.$createLabel()
            }
        },
        updateLabel() {
            if (this.loading && this.model.id) {
                return this.$translate('updating')
            } else {
                return this.$updateLabel()
            }
        },

    },
    watch: {},
    mounted() {
        if (this.item.id) this.model = { ...this.item }
        console.log('item', this.model)
    },
    methods: {
        cancel() {
            this.$emit('cancel')
        },
        onSubmit() {
            const model = { ...this.model }
            const path = model.id ? 'itemType/update' : 'itemType/create'
            this.$validator.validate().then(valid => {
                if (valid) {
                    this.loading = true
                    this.$store
                        .dispatch(path, model)
                        .then(() => {
                            this.loading = false
                            const action = model.id ? 'Updated' : 'Created';
                            const message = `${model.name} ${this.$translate(model.id ? 'update_alert' : 'create_alert')}`
                            this.$emit('success', action, message)
                        })
                        .catch(error => {
                            console.error('Item Type Submit Error', error)
                            this.$emit('error', error, model.name)
                        })
                        .finally(() => {
                            this.loading = false
                        })
                } else {
                    this.loading = false
                }
            })
        },

        deleteItem() {
            // Initializing key variables
            console.log('Attempt to delete')
            const model = { ...this.model }
            const path = 'itemType/delete'

            // Generate and display confirmation prompt
            const title = this.$translate('delete_item_type')
            const message = `${this.$translate('delete_note')} ${model.name}?`
            // const errorMsg = 'Unable to delete Item Type!'
            const toastMessage = `${model.name} ${this.$translate('delete_alert')}`;
            this.confirmMessage(title, message).then(result => {
                if (result) {
                    this.loading = true;
                    this.$store
                        .dispatch(path, model.id)
                        .then(() => {
                            this.loading = false;
                            this.$emit(
                                'success',
                                this.$translate('deleted'),
                                toastMessage
                            )
                        })
                        .catch(error => {
                            console.error(error)
                            this.loading = false;
                            this.doToast(
                                this.$translate('error'),
                                this.$translate('unable_alert'),
                                'danger'
                            )
                        })
                } else {
                    this.loading = false;
                }
            })
        },
    },
}
</script>
<style></style>
